import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_apple_pay_renaming~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_apple_pay_renaming/walking-f'
					),
			},
		},
		'activity-female-yoga': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_apple_pay_renaming~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_apple_pay_renaming/yoga-f'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_apple_pay_renaming~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_apple_pay_renaming/tai-chi-walking-f-v2'
					),
			},
		},
	},
]

export default config
